import {
  startOfMonth,
  endOfMonth,
  startOfQuarter,
  endOfQuarter,
  startOfYear,
  endOfYear,
  subMonths,
  subQuarters,
  subYears,
  subDays,
  differenceInCalendarMonths,
  differenceInCalendarDays,
  getMonth,
  getQuarter,
  getYear,
  format,
} from "date-fns";

/**
 * Tăng trưởng (%) = [(Giá trị kỳ này) - (Giá trị kỳ trước)] / (Giá trị kỳ trước) * 100
 * Kỳ trước = 0 thì không tính được tỷ lệ → trả về tyLe = null.
 */
export const tinhTangTruong = (giaTriKyNay, giaTriKyTruoc) => {
  const kyNay = Number(giaTriKyNay) || 0;
  const kyTruoc = Number(giaTriKyTruoc) || 0;
  const chenhLech = kyNay - kyTruoc;

  let tyLe = null;
  if (kyTruoc !== 0) {
    tyLe = (chenhLech / kyTruoc) * 100;
  } else if (kyNay === 0) {
    tyLe = 0;
  }

  return { kyNay, kyTruoc, chenhLech, tyLe };
};

/** Bỏ số 0 thừa ở phần thập phân: 18.15 → "18.15", 18.10 → "18.1", 18.00 → "18" */
export const dinhDangSo = (so, soLe = 2) =>
  so
    .toFixed(soLe)
    .replace(/(\.\d*?)0+$/, "$1")
    .replace(/\.$/, "");

export const formatKhoangNgay = (from, to) =>
  from && to ? `${format(from, "dd/MM/yyyy")} - ${format(to, "dd/MM/yyyy")}` : "";

const nhanTheoLoai = (loai, from, laKyTruoc) => {
  switch (loai) {
    case "year":
      return `Năm ${getYear(from)}`;
    case "month":
      return `Tháng ${getMonth(from) + 1}/${getYear(from)}`;
    case "quarter":
      return `Quý ${getQuarter(from)}/${getYear(from)}`;
    default:
      return laKyTruoc ? "Kỳ trước" : "Kỳ này";
  }
};

/**
 * Xác định kỳ so sánh liền trước dựa trên bộ lọc đang áp dụng.
 *
 * - Chọn "Tháng N"  → so với tháng liền trước
 * - Chọn "Quý N"    → so với quý liền trước
 * - Chọn "Tất cả"   → so với năm liền trước
 * - Lọc tùy chỉnh   → lùi cả 2 mốc ngày đúng bằng độ dài khoảng lọc
 *   (VD: 22/05/2026 - 22/06/2026 → 22/04/2026 - 22/05/2026)
 *
 * @returns {{ loai: string, kyNay: object, kyTruoc: object }|null}
 */
export const getKySoSanh = ({ dtFrom, dtTo, timeValue, isCustom }) => {
  if (!dtFrom || !dtTo) return null;

  let from;
  let to;
  let loai;
  const chonNhanh = !isCustom && typeof timeValue === "string";

  if (chonNhanh && timeValue === "all") {
    const goc = subYears(dtFrom, 1);
    from = startOfYear(goc);
    to = endOfYear(goc);
    loai = "year";
  } else if (chonNhanh && timeValue.startsWith("M")) {
    const goc = subMonths(dtFrom, 1);
    from = startOfMonth(goc);
    to = endOfMonth(goc);
    loai = "month";
  } else if (chonNhanh && timeValue.startsWith("Q")) {
    const goc = subQuarters(dtFrom, 1);
    from = startOfQuarter(goc);
    to = endOfQuarter(goc);
    loai = "quarter";
  } else {
    loai = "custom";
    const soNgay = differenceInCalendarDays(dtTo, dtFrom);
    const soThang = differenceInCalendarMonths(dtTo, dtFrom);
    // Kỳ trước luôn kết thúc đúng tại ngày bắt đầu của kỳ này và dài bằng kỳ này
    if (soNgay === 0) {
      from = subDays(dtFrom, 1);
      to = from;
    } else if (
      soThang >= 1 &&
      differenceInCalendarDays(subMonths(dtTo, soThang), dtFrom) === 0
    ) {
      // Khoảng lọc tròn tháng (VD: 22/05 - 22/06) → lùi đúng số tháng
      from = subMonths(dtFrom, soThang);
      to = dtFrom;
    } else {
      from = subDays(dtFrom, soNgay);
      to = dtFrom;
    }
  }

  return {
    loai,
    kyNay: {
      from: dtFrom,
      to: dtTo,
      nhan: nhanTheoLoai(loai, dtFrom, false),
      khoangNgay: formatKhoangNgay(dtFrom, dtTo),
    },
    kyTruoc: {
      from,
      to,
      nhan: nhanTheoLoai(loai, from, true),
      khoangNgay: formatKhoangNgay(from, to),
    },
  };
};
